// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Step Chart Component */
:host {
  width: 100%;
}

:host([disabled]) .ids-step-chart .step-chart-container .step {
  background-color: var(--ids-step-chart-step-disabled-color);
}

.ids-step-chart {
  contain: content;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  margin: var(--ids-step-chart-margin);
}
.ids-step-chart .step-label-container {
  margin-block-end: var(--ids-step-chart-inner-margin);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex: 1 1 auto;
}
.ids-step-chart .step-label-container .secondary-label {
  display: flex;
  flex-direction: row;
}
.ids-step-chart .step-label-container .secondary-label .completed-label {
  margin-inline-end: var(--ids-step-chart-inner-margin);
}
.ids-step-chart .step-label-container .secondary-label .icon {
  margin-inline-start: var(--ids-step-chart-inner-margin);
}
.ids-step-chart .step-chart-container {
  display: flex;
  flex-direction: row;
  flex: 1 1 auto;
}
.ids-step-chart .step-chart-container .step {
  background-color: var(--ids-step-chart-color-background-default);
  margin: calc(var(--ids-step-chart-inner-margin) - 3px);
  height: var(--ids-step-chart-height);
  box-sizing: content-box;
  border: 1px;
  flex: 1 1 auto;
}
.ids-step-chart .step-chart-container .step.complete {
  background-color: var(--ids-step-chart-color-background-complete);
}
.ids-step-chart .step-chart-container .step.in-progress {
  background-color: var(--ids-step-chart-color-background-progress);
}`, "",{"version":3,"sources":["webpack://./src/components/ids-step-chart/ids-step-chart.scss"],"names":[],"mappings":"AAAA,6BAAA;AAGA;EACE,WAAA;AADF;;AAOM;EACE,2DAAA;AAJR;;AAUA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,oCAAA;AAPF;AASE;EACE,oDAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;AAPJ;AASI;EACE,aAAA;EACA,mBAAA;AAPN;AASM;EACE,qDAAA;AAPR;AAUM;EACE,uDAAA;AARR;AAaE;EACE,aAAA;EACA,mBAAA;EACA,cAAA;AAXJ;AAaI;EACE,gEAAA;EACA,sDAAA;EACA,oCAAA;EACA,uBAAA;EACA,WAAA;EACA,cAAA;AAXN;AAaM;EACE,iEAAA;AAXR;AAcM;EACE,iEAAA;AAZR","sourcesContent":["/* Ids Step Chart Component */\n@use 'sass:list';\n\n:host {\n  width: 100%;\n}\n\n:host([disabled]) {\n  .ids-step-chart {\n    .step-chart-container {\n      .step {\n        background-color: var(--ids-step-chart-step-disabled-color);\n      }\n    }\n  }\n}\n\n.ids-step-chart {\n  contain: content;\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  margin: var(--ids-step-chart-margin);\n\n  .step-label-container {\n    margin-block-end: var(--ids-step-chart-inner-margin);\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    flex: 1 1 auto;\n\n    .secondary-label {\n      display: flex;\n      flex-direction: row;\n\n      .completed-label {\n        margin-inline-end: var(--ids-step-chart-inner-margin);\n      }\n\n      .icon {\n        margin-inline-start: var(--ids-step-chart-inner-margin);\n      }\n    }\n  }\n\n  .step-chart-container {\n    display: flex;\n    flex-direction: row;\n    flex: 1 1 auto;\n\n    .step {\n      background-color: var(--ids-step-chart-color-background-default);\n      margin: calc(var(--ids-step-chart-inner-margin) - 3px);\n      height: var(--ids-step-chart-height);\n      box-sizing: content-box;\n      border: 1px;\n      flex: 1 1 auto;\n\n      &.complete {\n        background-color: var(--ids-step-chart-color-background-complete);\n      }\n\n      &.in-progress {\n        background-color: var(--ids-step-chart-color-background-progress);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
